import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '20px',
  maxWidth: 300,
  borderRadius: '5px'
};

export default function BasicModal({
  open,
  title,
  description,
  confrimText,
  onConfirm,
  cancelText,
  onCancel,
  onClose,
  ...props
}) {
  return (
    <Modal
      {...props}
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        {title && <Typography id='modal-modal-title' variant='h6' component='h2'>{title}</Typography>}
        {description && <Typography id='modal-modal-description' sx={title ? { mt: 2, wordBreak: 'break-word', whiteSpace: 'pre-line' } : { wordBreak: 'break-word', whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: description }} />}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {onCancel && cancelText && <Button onClick={onCancel} sx={{ mt: 2, ml: 2, fontWeight: 'bold' }} color='secondary'>{cancelText}</Button>}
          {onConfirm && confrimText && <Button onClick={onConfirm} sx={{ mt: 2, ml: 2, fontWeight: 'bold' }} color='secondary'>{confrimText}</Button>}
        </Box>
      </Box>
  </Modal>
  );
}